// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-certificate {
  border-left: 2px solid #ddd;
  padding: 30px 15px;
}

.fil {
  margin-top: 50px;
  font-size: 30px;
  color: #0b365f;
}

.cer-tab {
  border-bottom: 1px solid lightgray;
  border-bottom-color: #707070;
  font-size: 20px;
}

.cer-tab td {
  padding: 10px 0px;
  width: 50%;
}

.cer-head {
  color: #0f5597;
  font-weight: 600;
}

.cer-text {
  color: #58595b;
  text-align: right;
}

.understand {
  font-size: 20px;
  margin: 30px 0;
}

.emil {
  font-size: 20px;
  color: #58595b;
  font-weight: 400;
  margin-left: 10px;
  float: right;
  width: 97%;
}

.certify-list li {
  color: #58595b;
  list-style-type: lower-alpha;
  margin-left: 20px;
}

.cer-btn {
  float: right;
  margin-top: 30px;
  width: 100%;
}

.wht-btn {
  background-color: #fff;
  border: none;
  padding: 0px 25px;
  font-weight: 600;
  color: #848484;
}

.blu-btn.k-button {
  background-color: #0f5597;
  padding: 8px 25px;
  font-size: 20px;
  text-transform: unset;
  border-radius: 0;
  height: 50px;
}

.note {
  width: 100%;
}

.t-a-r {
  text-align: right;
}

.status {
  color: #0f5597;
  font-weight: 400;
  margin-right: 10px;
  font-size: normal;
}

.status-dropdown.k-dropdown {
  width: 100%;
  max-width: 300px;
  height: 50px;
  background-color: #ebebeb;
}

.cand-stat {
  width: 35%;
  background-color: #eee;
  border: none;
  border-bottom: 1px solid #58595b;
  padding: 5px;
}

.bak {
  font-weight: 600;
}

.signature {
  text-align: center;
  color: #58595b;
  font-size: 24px;
}

.signature-pad {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 250px;
  background-color: white;
}

.dot-border {
  border: 1px dashed #aaaaaa;
  margin-top: 40px;
  padding: 0 30px 0 30px;
}

.cros {
  border-bottom: 2px solid #ddd;
  color: #ddd;
  padding: 5px;
}

.cros .k-button .k-icon {
  font-size: 24px;
}

.k-textarea {
  background: #ffffff;
  border: solid #aeaeae 1px;
}

.k-dropdownlist,
.k-dropdown {
  background: #ebebeb;
}

.matform-Container {
  padding-left: 20px;
}

.font-600 {
  font-weight: 500 !important;
}

.text-color {
  color: #0f5597;
}

.sub-section-3 {
  width: 100%;
}

.padding-class {
  margin-top: 50px;
  margin-bottom: 50px;
}

.btn-join {
  border: 1px solid #0f5597 !important;
  color: #0f5597;
  background-color: #fafafa;
}

.sub-section-1 {
  width: 100%;
}

.addnote-class {
  width: 100%;
  height: 100%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

.subject-class {
  width: 100%;
  height: 100%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

.download-button {
  border: 1px solid #005596;
  color: #005596;
}

.btn-class {
  float: right;
}

.deactive-modal {
  min-height: 90px;
  resize: none !important;
  padding: 15px 12px !important;
  width: 100%;
  border: 1px solid black;
}

.active-modal {
  min-height: 50px;
  resize: none !important;
  padding: 15px 12px !important;
  width: 100%;
  border: 1px solid black;
}

.navigatepadding {
  padding-left: 20px;
}

.fontcolorblck {
  color: #0f5597;
  font-size: 19px;
}

.value {
  float: right;
  font-size: 19px;
}

.sub-section-2 {
  min-width: 40%;
}

@media screen and (max-width: 992px) {
  .sub-section-2 {
    width: 80%;
  }
}
/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 720px) {
  .sub-section-2 {
    width: 100%;
  }
}
.color-NavyBlue {
  color: #002d56;
  font-weight: 500;
}

.table-underline {
  border-collapse: collapse;
}
.table-underline tr {
  border-bottom: 1px solid #ccc;
}
.table-underline th,
.table-underline td {
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/current-committee/current-committee.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,kCAAA;EACA,4BAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;EACA,4BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AACJ;;AAEA;EACI,UAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,yBAAA;AACJ;;AAEA;;EAEI,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,cAAA;EACA,yBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,uBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI;IACI,UAAA;EACN;AACF;AAEA,yEAAA;AACA;EACI;IACI,WAAA;EAAN;AACF;AAGA;EACI,cAAA;EACA,gBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;AAEI;EACI,6BAAA;AAAR;AAEI;;EAEI,YAAA;AAAR","sourcesContent":[".first-certificate {\n    border-left: 2px solid #ddd;\n    padding: 30px 15px;\n}\n\n.fil {\n    margin-top: 50px;\n    font-size: 30px;\n    color: #0b365f;\n}\n\n.cer-tab {\n    border-bottom: 1px solid lightgray;\n    border-bottom-color: #707070;\n    font-size: 20px;\n}\n\n.cer-tab td {\n    padding: 10px 0px;\n    width: 50%;\n}\n\n.cer-head {\n    color: #0f5597;\n    font-weight: 600;\n}\n\n.cer-text {\n    color: #58595b;\n    text-align: right;\n}\n\n.understand {\n    font-size: 20px;\n    margin: 30px 0;\n}\n\n.emil {\n    font-size: 20px;\n    color: #58595b;\n    font-weight: 400;\n    margin-left: 10px;\n    float: right;\n    width: 97%;\n}\n\n.certify-list li {\n    color: #58595b;\n    list-style-type: lower-alpha;\n    margin-left: 20px;\n}\n\n.cer-btn {\n    float: right;\n    margin-top: 30px;\n    width: 100%;\n}\n\n.wht-btn {\n    background-color: #fff;\n    border: none;\n    padding: 0px 25px;\n    font-weight: 600;\n    color: #848484;\n}\n\n.blu-btn.k-button {\n    background-color: #0f5597;\n    padding: 8px 25px;\n    font-size: 20px;\n    text-transform: unset;\n    border-radius: 0;\n    height: 50px;\n}\n\n.note {\n    width: 100%;\n}\n\n.t-a-r {\n    text-align: right;\n}\n\n.status {\n    color: #0f5597;\n    font-weight: 400;\n    margin-right: 10px;\n    font-size: normal;\n}\n\n.status-dropdown.k-dropdown {\n    width: 100%;\n    max-width: 300px;\n    height: 50px;\n    background-color: #ebebeb;\n}\n\n.cand-stat {\n    width: 35%;\n    background-color: #eee;\n    border: none;\n    border-bottom: 1px solid #58595b;\n    padding: 5px;\n}\n\n.bak {\n    font-weight: 600;\n}\n\n.signature {\n    text-align: center;\n    color: #58595b;\n    font-size: 24px;\n}\n\n.signature-pad {\n    position: relative;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 250px;\n    background-color: white;\n}\n\n.dot-border {\n    border: 1px dashed #aaaaaa;\n    margin-top: 40px;\n    padding: 0 30px 0 30px;\n}\n\n.cros {\n    border-bottom: 2px solid #ddd;\n    color: #ddd;\n    padding: 5px;\n}\n\n.cros .k-button .k-icon {\n    font-size: 24px;\n}\n\n.k-textarea {\n    background: #ffffff;\n    border: solid #aeaeae 1px;\n}\n\n.k-dropdownlist,\n.k-dropdown {\n    background: #ebebeb;\n}\n\n.matform-Container {\n    padding-left: 20px;\n}\n\n.font-600 {\n    font-weight: 500 !important;\n}\n\n.text-color {\n    color: #0f5597;\n}\n\n.sub-section-3 {\n    width: 100%;\n}\n\n.padding-class {\n    margin-top: 50px;\n    margin-bottom: 50px;\n}\n\n.btn-join {\n    border: 1px solid #0f5597 !important;\n    color: #0f5597;\n    background-color: #fafafa;\n}\n\n.sub-section-1 {\n    width: 100%;\n}\n\n.addnote-class {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    border: 1px solid black;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n\n.subject-class {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    border: 1px solid black;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n\n.download-button {\n    border: 1px solid #005596;\n    color: #005596;\n}\n\n.btn-class {\n    float: right;\n}\n\n.deactive-modal {\n    min-height: 90px;\n    resize: none !important;\n    padding: 15px 12px !important;\n    width: 100%;\n    border: 1px solid black;\n}\n\n.active-modal {\n    min-height: 50px;\n    resize: none !important;\n    padding: 15px 12px !important;\n    width: 100%;\n    border: 1px solid black;\n}\n\n.navigatepadding {\n    padding-left: 20px;\n}\n\n.fontcolorblck {\n    color: #0f5597;\n    font-size: 19px;\n}\n\n.value {\n    float: right;\n    font-size: 19px;\n}\n\n.sub-section-2 {\n    min-width: 40%;\n}\n\n@media screen and (max-width: 992px) {\n    .sub-section-2 {\n        width: 80%;\n    }\n}\n\n/* On screens that are 600px or less, set the background color to olive */\n@media screen and (max-width: 720px) {\n    .sub-section-2 {\n        width: 100%;\n    }\n}\n\n.color-NavyBlue {\n    color: #002d56;\n    font-weight: 500;\n}\n\n.table-underline {\n    border-collapse: collapse;\n    tr {\n        border-bottom: 1px solid #ccc;\n    }\n    th,\n    td {\n        padding: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
